<template>
  <div class="container">
    <header class="jumbotron">
      <h3>{{content.header}}</h3>
      <div>{{content.body}}</div>
      <div>{{content.body2}}</div>
      <div v-if="!currentUser">
        <form action="/auth/vipps/start_login">
          <input type="submit" value="Logg inn med Vipps" >
        </form>
        <!-- <a :href="loginUrl">TESTLINK</a> -->
      </div>
      <div v-else>
        <a class="nav-link" href @click.prevent="logOut">
          <font-awesome-icon icon="sign-out-alt" />Logg ut
        </a>
      </div>
    </header>
  </div>
</template>

<script>
import UserService from '../services/user.service';
import vippsopenconfig from '../config/vipps_open.config';

export default {
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    loginUrl() {
      var loginurl = `https://api.vipps.no/access-management-1.0/access/oauth2/auth?client_id=${vippsopenconfig.client_id}&response_type=code&`
        + `scope=${encodeURIComponent(vippsopenconfig.scope)}&state=${vippsopenconfig.state}&redirect_uri=${vippsopenconfig.redirect_uri}`
      return loginurl;
    }
  },
  name: 'Home',
  data() {
    return {
      content: {}
    };
  },
  mounted() {
    UserService.getPublicContent().then(
      response => {
        this.content = response.data;
      },
      error => {
        this.content =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
      }
    );
    this.content.loginUrl = this.loginUrl;
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/');
    }
  }
};
</script>